'use strict';

function addBackupToPdfLinks() {
    // Get all <a> tags with a .pdf extension in their href attribute
    const pdfLinks = document.querySelectorAll('a[href$=".pdf"]');

    // Loop through each <a> tag and modify its href attribute
    pdfLinks.forEach(link => {
    // Get the original href value
    const originalHref = link.getAttribute('href');
    
    // Construct the new href value with "backup/" added
    const newHref = originalHref.replace(/(\/uploads\/)/, '$1backup/');
    
    // Set the href attribute to the new value
    link.setAttribute('href', newHref);
    });	
}

export default addBackupToPdfLinks;
